/*
 * iurop-cart-drawer — Side-cart Kawaicafe.
 *   · Cantidad (± ) y eliminar → /cart/change.js → re-render de la sección.
 *   · Cross-sell "Completa tu pedido" → /cart/add.js → re-render.
 *   · Temporizador de reserva (cuenta atrás, persistida en localStorage).
 * Delegación de eventos en document → sobrevive al re-render del drawer.
 * Sin dependencias.
 */
(function () {
  'use strict';

  // En /cart la seccion se renderiza DOS veces (side-cart global + panel de
  // pagina) y con ella su <script src>, asi que el modulo se ejecutaba dos
  // veces y cada clic disparaba DOS mutaciones: "eliminar" borraba dos lineas.
  if (window.__iuropCartInit) return;
  window.__iuropCartInit = true;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // Shopify contesta 422 (con {description, message}) cuando la cantidad
      // pedida no tiene stock. Sin mirar r.ok la promesa RESOLVIA y el drawer
      // daba el cambio por bueno: la cantidad se quedaba igual y nadie avisaba.
      // Mismo patron que addToCart() en assets/iurop-product.js.
      if (!r.ok) {
        return r.json().then(
          function (e) { throw e; },
          function () { throw { status: r.status }; }
        );
      }
      return r.json();
    });
  }

  function updateCounts() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        // Con 0 items el badge se oculta (QA: no mostrar "0" colgando del icono).
        el.classList.toggle('is-zero', cart.item_count === 0);
      });
    }).catch(function () {});
  }

  // Flechas del upsell "Completa tu pedido": ocultas en los extremos (regla de
  // diseño iUROP §4b — al inicio solo se ve la derecha; al final desaparece la
  // derecha). Listener de scroll en fase de CAPTURA (scroll no burbujea) para
  // sobrevivir a los re-renders del drawer.
  function syncUpsellNav() {
    // TODAS las instancias: en /cart conviven el side-cart y el panel de pagina.
    document.querySelectorAll('[data-cart-upsell]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-upsell-track]');
      var prev = wrap.querySelector('[data-upsell-prev]');
      var next = wrap.querySelector('[data-upsell-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      next.classList.toggle('is-hidden', max <= 0 || track.scrollLeft >= max);
    });
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-upsell-track]')) syncUpsellNav();
  }, true);

  // Re-render con el carrito ya actualizado (Section Rendering API).
  // Hay DOS instancias posibles de la misma seccion: el side-cart global de
  // theme.liquid y, en /cart, el mismo componente en modo pagina. Se refrescan
  // las dos: si solo se refrescara el drawer, la pagina /cart se quedaria con
  // las cantidades viejas tras un +/-.
  function refreshOne(sectionId, selector, keepOpen) {
    return fetch(window.location.pathname + '?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        var holder = document.getElementById('shopify-section-' + sectionId);
        if (!html || !holder) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector(selector);
        var current = holder.querySelector(selector);
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        if (keepOpen) {
          fresh.setAttribute('data-open', 'true');
          // a11y: el nodo fresco vuelve con aria-hidden="true" horneado (QA §5.5).
          fresh.setAttribute('aria-hidden', 'false');
          document.documentElement.setAttribute('data-drawer-open', 'true');
        }
      })
      .catch(function () {});
  }

  function pageSectionId() {
    var el = document.querySelector('[data-cart-page]');
    var host = el && el.closest('[id^="shopify-section-"]');
    return host ? host.id.replace('shopify-section-', '') : null;
  }

  function rerender(keepOpen, opts) {
    var jobs = [];
    if (document.querySelector('[data-cart-drawer]')) {
      jobs.push(refreshOne('iurop-cart-drawer', '[data-cart-drawer]', keepOpen));
    }
    var pid = pageSectionId();
    if (pid) jobs.push(refreshOne(pid, '[data-cart-page]', false));
    return Promise.all(jobs).then(function () { refreshDrawerUI(opts); });
  }

  // Punto UNICO de re-sincronizacion de la UI del drawer tras cualquier cambio
  // del carrito, venga de esta seccion o de otro script (PDP, quick-add...).
  function refreshDrawerUI(opts) {
    updateCounts();
    initTimer(opts && opts.reset);
    syncUpsellNav();
  }
  // Contrato cross-agente: quien mute el carrito dispara `cart:updated`.
  document.addEventListener('cart:updated', function (e) {
    refreshDrawerUI({ reset: !!(e.detail && e.detail.added) });
  });

  function isOpen() {
    var d = document.querySelector('[data-cart-drawer]');
    return d && d.hasAttribute('data-open');
  }

  // Aviso de error EN LA LINEA sin nodos nuevos: el texto viaja en un atributo y
  // lo pinta el CSS del drawer (::after). Si ese CSS no estuviera, el resultado
  // es el de hoy (nada visible) — nunca deja la UI peor de lo que estaba.
  function lineError(item, err) {
    if (!item) return;
    var msg = (err && (err.description || err.message)) || 'No hemos podido actualizar el carrito';
    item.setAttribute('data-cart-error', msg);
    window.setTimeout(function () { item.removeAttribute('data-cart-error'); }, 4000);
  }

  function changeLine(line, qty) {
    var open = isOpen();
    var item = document.querySelector('[data-cart-item][data-line="' + line + '"]');
    if (item) item.classList.add('is-busy');
    return postJSON('/cart/change.js', { line: parseInt(line, 10), quantity: qty })
      .then(function () { return rerender(open); })
      .catch(function (err) {
        // Sin este catch la linea se quedaba con .is-busy PARA SIEMPRE (opacity .5
        // + pointer-events:none = fila muerta hasta recargar) en cuanto el fetch
        // fallara de verdad. Se suelta la fila, se repinta con el estado REAL del
        // servidor y se dice el motivo.
        if (item) item.classList.remove('is-busy');
        return rerender(open).then(function () {
          lineError(document.querySelector('[data-cart-item][data-line="' + line + '"]'), err);
        });
      });
  }

  function addUpsell(id, btn) {
    var open = isOpen();
    var label = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    return postJSON('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
      .then(function () { resetTimer(); return rerender(open, { reset: true }); })
      .catch(function (err) {
        // Mismo aviso que la PDP (assets/iurop-product.js): el propio boton dice
        // "Sin stock" un par de segundos y vuelve a su texto. Antes un 422 se
        // trataba como exito y el producto no llegaba a aparecer en el carrito.
        if (!btn) return;
        btn.disabled = false;
        if (err && err.description) {
          btn.textContent = 'Sin stock';
          window.setTimeout(function () { btn.textContent = label; }, 2000);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-minus]');
    var plus = e.target.closest('[data-cart-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    var upadd = e.target.closest('[data-cart-upadd]');
    var upNav = e.target.closest('[data-upsell-prev], [data-upsell-next]');

    if (minus) {
      var li = minus.closest('[data-cart-item]');
      var v = parseInt(li.querySelector('[data-qty-val]').textContent, 10) || 1;
      changeLine(minus.getAttribute('data-cart-minus'), Math.max(0, v - 1));
    } else if (plus) {
      var li2 = plus.closest('[data-cart-item]');
      var v2 = parseInt(li2.querySelector('[data-qty-val]').textContent, 10) || 1;
      changeLine(plus.getAttribute('data-cart-plus'), v2 + 1);
    } else if (remove) {
      changeLine(remove.getAttribute('data-cart-remove'), 0);
    } else if (upadd) {
      addUpsell(upadd.getAttribute('data-cart-upadd'), upadd);
    } else if (upNav) {
      var wrap = upNav.closest('[data-cart-upsell]');
      var track = wrap && wrap.querySelector('[data-upsell-track]');
      if (track) {
        var card = track.querySelector('.kawaii-cart__up-card');
        var step = card ? card.offsetWidth + 12 : 260;
        track.scrollBy({ left: upNav.hasAttribute('data-upsell-next') ? step : -step, behavior: 'smooth' });
      }
    }
  });

  // ---- Temporizador de reserva ---------------------------------------------
  // El drawer se re-renderiza por Section Rendering API y vuelve con el reloj
  // HORNEADO en "10:00": si nadie re-arranca el temporizador sobre el nodo
  // NUEVO, el intervalo viejo sigue escribiendo en el nodo desechado y el
  // cliente ve el contador congelado en 10:00 hasta el siguiente clic (QA
  // sidecart). Por eso todo re-render termina en refreshDrawerUI().
  var timerInt = null;
  var KEY = 'kc-reserve-start';
  function resetTimer() {
    try { localStorage.setItem(KEY, String(Math.floor(Date.now() / 1000))); } catch (_) {}
  }
  function initTimer(reset) {
    var els = [].slice.call(document.querySelectorAll('[data-cart-timer]'));
    var clocks = els.map(function (e) { return e.querySelector('[data-cart-clock]'); }).filter(Boolean);
    var el = els[0];
    if (!clocks.length) { if (timerInt) { clearInterval(timerInt); timerInt = null; } return; }
    var total = (parseInt(el.getAttribute('data-reserve-mins'), 10) || 10) * 60;
    var start = parseInt(localStorage.getItem(KEY), 10);
    var now = Math.floor(Date.now() / 1000);
    // Al anadir producto la reserva vuelve a empezar (QA sidecart: "no se
    // reinicia al anadir nuevos productos").
    if (reset || !start || now - start >= total) { start = now; localStorage.setItem(KEY, String(start)); }
    function tick() {
      var left = total - (Math.floor(Date.now() / 1000) - start);
      if (left <= 0) { start = Math.floor(Date.now() / 1000); localStorage.setItem(KEY, String(start)); left = total; }
      var m = Math.floor(left / 60), sec = left % 60;
      var txt = m + ':' + (sec < 10 ? '0' + sec : sec);
      clocks.forEach(function (c) { c.textContent = txt; });
    }
    if (timerInt) clearInterval(timerInt);
    tick();
    timerInt = setInterval(tick, 1000);
  }

  function boot() { initTimer(); syncUpsellNav(); }
  window.iuropCartDrawer = { refresh: refreshDrawerUI, resetReserve: resetTimer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Al abrir el carrito desde cualquier [data-cart-open], asegura el temporizador.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) window.setTimeout(initTimer, 60);
  });
  // En /cart la seccion pinta [data-cart-page] en vez de [data-cart-drawer]: hay que
  // cubrir las dos o, al tocar un ajuste en el editor, el contador se queda congelado.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cart-drawer], [data-cart-page]')) initTimer();
  });
})();
